import { useEffect, useState } from "react";

/**
 * A ~20 line router. The app has exactly two screens, so pulling in a routing
 * library would be more configuration than code.
 */
export function useRoute(): string {
  const [path, setPath] = useState(() => window.location.pathname);

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  return path;
}

export function navigate(to: string): void {
  if (to === window.location.pathname) return;
  window.history.pushState({}, "", to);
  // pushState doesn't fire popstate, so nudge subscribers ourselves.
  window.dispatchEvent(new PopStateEvent("popstate"));
}

/** Returns the game id for a /g/:id path, or null. */
export function gameIdFromPath(path: string): string | null {
  const match = /^\/g\/([a-z2-9]{4,32})\/?$/.exec(path);
  return match?.[1] ?? null;
}
